<template>
  <FinderCard
    data-test="finder-conditions-card"
    :title="criterion.title"
    :tooltip="criterion.tooltip"
  >
    <ul class="flex w-full flex-col gap-8">
      <li
        v-for="(option, index) in criterion.options"
        :key="option.id"
        class="w-full"
      >
        <RevButtonBase
          :aria-pressed="isGradeSelected(index)"
          class="flex w-full items-center rounded-lg border px-16 py-14 transition-colors"
          :class="
            isGradeSelected(index)
              ? 'border-action-brand-mid bg-action-brand-low text-static-default-hi'
              : 'border-transparent bg-surface-default-hi text-static-default-hi hover:bg-surface-default-mid'
          "
          :data-state="isGradeSelected(index) ? 'selected' : 'unselected'"
          :data-test="`finder-conditions-option-${option.id}`"
          @click="handleClick(option.id)"
        >
          <span class="grow text-left heading-3">{{ option.label }}</span>
        </RevButtonBase>
      </li>
    </ul>
  </FinderCard>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { RevButtonBase } from '@ds/components/ButtonBase'

import type { FinderConditionsCriterion } from '../../../../composables/useFinder/useFinder.types'
import FinderCard from '../FinderCard/FinderCard.vue'

const props = defineProps<{
  criterion: FinderConditionsCriterion
}>()

const model = defineModel<string | undefined>()

const thresholdIndex = computed(() => {
  if (!model.value) return -1

  return props.criterion.options.findIndex(
    (option) => option.id === model.value,
  )
})

function isGradeSelected(index: number): boolean {
  return thresholdIndex.value >= 0 && index >= thresholdIndex.value
}

function handleClick(optionId: string): void {
  model.value = model.value === optionId ? undefined : optionId
}
</script>
